export const TEMPORARY_PRODUCT_LICENSE_ID_KEY: string = 'webshopDemoLicenseId';
